import { createApi } from "@reduxjs/toolkit/query/react";
import { Endpoints, convertTag } from "services/urls";
import { baseQuery } from "utils/baseQuery";
import { apiHelper } from "../utils/apiHelper";
import { IDashboardOverview } from "../types/message.types";

const DASHBOARD_TAGS = {
  overview: "dashboard-overview",
};

const DashboardApi = createApi({
  reducerPath: "dashboard-api",
  baseQuery: baseQuery(),
  tagTypes: [DASHBOARD_TAGS.overview],
  endpoints: (builder) => ({
    dashboardOverview: builder.query<IDashboardOverview, void>({
      providesTags: [convertTag(DASHBOARD_TAGS.overview)],
      query: () => apiHelper(Endpoints.dashboard.overview, {}),
    }),
  }),
});

export const { useDashboardOverviewQuery } = DashboardApi;
export { DashboardApi, DASHBOARD_TAGS };
